import { Sun, Monitor, Moon } from 'lucide-react';
import { useTheme } from './ThemeProvider';
import { cn } from '@/lib/utils';

const options = [
  { value: 'light' as const, icon: Sun, label: 'Claro' },
  { value: 'system' as const, icon: Monitor, label: 'Sistema' },
  { value: 'dark' as const, icon: Moon, label: 'Escuro' },
];

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  return (
    <div className="flex items-center gap-1 rounded-lg bg-sidebar-active/30 p-1">
      {options.map(({ value, icon: Icon, label }) => (
        <button
          key={value}
          onClick={() => setTheme(value)}
          title={label}
          className={cn(
            'flex items-center justify-center rounded-md p-1.5 transition-colors',
            theme === value
              ? 'bg-sidebar-active text-white'
              : 'text-sidebar-foreground/50 hover:text-sidebar-foreground/80',
          )}
        >
          <Icon size={14} />
        </button>
      ))}
    </div>
  );
}
